// Context/BrandContext.js
import { createContext, useContext, useState, useEffect } from "react";
import { getLocalStorageItem } from "../Utils/Index";
import { getBrand } from "../ApiService/Apis/Items/Item";
// import { getBrand } from "../ApiService/Apis/Items/Item";

const BrandContext = createContext();

export const BrandProvider = ({ children }) => {
  const [brand, setBrand] = useState(null);

  const FetchBrandDetails = async () => {
    try {
      const res = await getBrand(getLocalStorageItem("userDetail")?.restaurantId);
      if (res.status && res.data) {
        setBrand(res.data); // store logo, color, title
      }
    } catch (err) {
      console.error("Brand fetch failed", err);
    }
  };


  useEffect(() => {
    if (brand?.theme_color) {
      document.documentElement.style.setProperty("--brand-color", brand.theme_color);
    }
    if (brand?.text_color) {
      document.documentElement.style.setProperty("--text-color", brand.text_color);
    }
    if (brand?.bg_color1) {
      document.documentElement.style.setProperty("--bg-color1", brand.bg_color1);
    }
    if (brand?.bg_color2) {
      document.documentElement.style.setProperty("--bg-color2", brand.bg_color2);
    }
  }, [brand]);

  useEffect(() => {
    if (brand?.title) {
      document.title = brand.title; // ✅ Change tab title
    }
  }, [brand]);
  useEffect(() => {
    if (getLocalStorageItem("access_token")) {
      FetchBrandDetails();
    }
  }, []);

  return (
    <BrandContext.Provider value={brand}>
      {children}
    </BrandContext.Provider>
  );
};

// custom hook for easy access
export const useBrand = () => useContext(BrandContext);
